<div [ngClass]="{'has-background': hasBackgroundImage}">

    @if(hasBackgroundImage && backgroundImageUrl) {
    <div class="background-image" [style.opacity]="backgroundOpacity">
        <img [src]="backgroundImageUrl" [alt]="imageAlt + ' background'">
    </div>
    }

    <div class="container-md">
        <div class="row align-items-center g-5 p-3">
            <div class="col-12 col-xl-6" [ngClass]="{'order-xl-2': imagePosition === 'right'}">
                <div class="image-container d-flex justify-content-center"
                    [ngClass]="{'size-tall': imageSize === 'tall', 'size-square': imageSize === 'square'}">
                    <img [src]="imageUrl" [alt]="imageAlt" [attr.fetchpriority]="fetchPriority" class="img-fluid">
                </div>
            </div>
            <div class="col-12 col-xl-6" [ngClass]="{'order-xl-1': imagePosition === 'right'}">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>